import script from "./WireInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./WireInstructions.vue?vue&type=script&setup=true&lang=js"

import "./WireInstructions.vue?vue&type=style&index=0&id=1c3f4051&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c3f4051"]])

export default __exports__